module.exports = __webpack_public_path__ + "static/img/office_4.37c32f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/recruit_2021/welfare/office_4.png
// module id = M4L3
// module chunks = 0